<template>
    <div name="auth">
        <loading v-if="isLoading" />
    </div>
</template>

<script>
import axios from 'axios';
import CampaignAuth from '@/utilities/campaignAuth';
import Loading from '@/components/molecules/Loading';

export default {
    name: 'auth',
    data: function()
    {
        return {
            code: '',
            state: '',
            isLoading: true
        }
    },
    components: {Loading},
    mounted: function()
    {
        ChannelIO('shutdown')
        this.code = this.$route.query.code;
        this.state = this.$route.query.state;
        this.getKakaoToken(this.code)
    },
    methods: {
        getKakaoToken: function(code){
            axios({
                method: 'post',             
                params: {
                    client_id: process.env.KAKAO_REST_API_KEY,
                    code,
                    grant_type: 'authorization_code',
                    // client_secret: 'test'   //  배포시 제거하여 배포
                },
                url: 'https://kauth.kakao.com/oauth/token',
                withCredentials: false,

            }).then((response) => {

                // state에 campaign 이 있으면 카카오 액세스 토큰을 저장하고 돌아간다
                // (글쓰기/좋아요 API 가 토큰으로 사용자를 확인한다)
                if(this.state.indexOf('/campaign') > -1)
                {
                    CampaignAuth.setToken(response.data.access_token)
                    window.location.href = `${this.state}`;
                }
                else 
                {
                    window.location.href = `${this.state}&kakao=${response.data.access_token}`;  
                }
                
                
                // 
            }).catch((err) => {
                // alert(err)
                // console.log("error")
            })
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/Auth.vue